import { actionTypes as drawerActionTypes } from './drawer.actions';

export const initialState = {
    isDrawerMinimized: true,
    theme: 'no-bookmaker',
    isQuickslipMode: true,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case drawerActionTypes.MINIMIZE_DRAWER:
            return {
                ...state,
                isDrawerMinimized: true,
            };
        case drawerActionTypes.MAXIMIZE_DRAWER:
            return {
                ...state,
                isDrawerMinimized: false,
            };
        case drawerActionTypes.SET_THEME:
            return {
                ...state,
                theme: action.theme,
            };
        case drawerActionTypes.SET_QUICKSLIP_MODE:
            return {
                ...state,
                isQuickslipMode: action.enabled,
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/drawer/drawer.reducer.js